import {GameDataStore} from "../../../src/GameDataStore";
import {CONST} from "../../../src/const";

class BonusGameComponent extends SlotGame.src.component.BonusGameComponent {

    protected isPlatinumJackpot: boolean = false;
    protected particleContainer;
    protected isOutroPopupClicked: boolean = true;
    private isIntroPopupClicked = false;
    private timeIntroTransitionSound = 9000;
    private timeOutroTransitionSound = 9000;
    private timePlayCounterAnimation = 3000;
    private timeWaitStopPlayCounterAnimation = 2000;

    static events = {
        START_INTRO_POPUP: "BonusGameComponent.START_INTRO_POPUP",
        START_HIDE_INTRO_POPUP: "BonusGameComponent.START_HIDE_INTRO_POPUP",
        END_INTRO_POPUP: "BonusGameComponent.END_INTRO_POPUP",
        START_HIDE_END_INTRO_POPUP: "BonusGameComponent.START_HIDE_END_INTRO_POPUP",
        START_OUTRO_POPUP: "BonusGameComponent.START_OUTRO_POPUP",
        END_OUTRO_POPUP: "BonusGameComponent.END_OUTRO_POPUP",
        START_WIN_PLATINUM: "BonusGameComponent.START_WIN_PLATINUM",
        END_WIN_PLATINUM: "BonusGameComponent.END_WIN_PLATINUM",
        START_HIDE_PLATINUM_POPUP: "BonusGameComponent.START_HIDE_PLATINUM_POPUP",
        PLATINUM_POPUP_START_COUNT: "BonusGameComponent.PLATINUM_POPUP_START_COUNT",
        PLATINUM_POPUP_END_COUNT: "BonusGameComponent.PLATINUM_POPUP_END_COUNT",
        OUTRO_POPUP_START_COUNT: "BonusGameComponent.OUTRO_POPUP_START_COUNT",
        OUTRO_POPUP_END_COUNT: "BonusGameComponent.OUTRO_POPUP_END_COUNT",
    }

    constructor(config) {
        super(config);

        this.status_checkers = {
            ...super.getStatusCheckers(),

            isPlatinumJackpot: () => this.isPlatinumJackpot,
        };

        this.text_checkers = {
            ...super.getTextCheckers(),

            GET_TOTAL_WIN_NUMBER: () => this.store.toFormatMoney(this.store.gameData.bonusGame.win),
            GET_PLATINUM_VALUE: () => this.store.toFormatMoney(this.store.gameData.bet * CONST.JACKPOT.PLATINUM_MULTIPLIER),
        };
    }

    async onGameReady() {
        super.onGameReady();

        game.onData('game.fsm.CHANGE_STATE_PHASE', {state: 'SPIN', phase: 'endSpin' }, () => {
            this.isPlatinumJackpot = (<GameDataStore>this.store.gameData).isPlatinumJackpot;
        });
    }

    async showStartPopup() {
        this.gameData.isBonusGamePopupsInProgress = true;

        game.emit("BonusGameComponent.START_INTRO_POPUP");

        const container = game.tree.findByName('bonus_game.wrapper_container.popup_intro_container');

        container.options.visible = true;

        await game.utils.GameUtils.playAlphaAnimation(container, {from: 0, to: 1, time: 500, timeWait: 0});


        await Promise.race([
            game.utils.delay(this.timeIntroTransitionSound),
            this.waitClick(),
            game.onceDataPromise('Button.clicked', {
                component: 'bonusGame',
                name: 'bonus_game.popup_intro.wrapper_container.skip'
            }).then(() => {
                this.isIntroPopupClicked = true
            })
        ]);


        game.emit(BonusGameComponent.events.START_HIDE_INTRO_POPUP);
        await game.utils.GameUtils.playAlphaAnimation(container, {from: 1, to: 0, time: 500, timeWait: 0});

        game.emit("BonusGameComponent.END_INTRO_POPUP", {});
    }

    async showFinishPopup() {
        this.gameData.isBonusGamePopupsInProgress = false;
        
        if (this.isPlatinumJackpot) {
            game.emit("BonusGameComponent.START_WIN_PLATINUM");
            this.createCoinParticles();
            await this.showOutroJackpotPopup();
            game.emit("BonusGameComponent.END_WIN_PLATINUM");
            game.utils.PIXIUtils.remove(this.particleContainer);
        }

        game.emit("BonusGameComponent.START_OUTRO_POPUP");

        await this.showOutroPopup();
        
        game.emit("BonusGameComponent.END_OUTRO_POPUP", {});

        if (!this.gameData.isFreespinGamePopupsInProgress) game.emit("BonusGameComponent.END_OUTRO_POPUP.PlayMainSound");
    }

    async showOutroPopup() {
        const container = game.tree.findByName('bonus_game.wrapper_container.popup_outro_container');
        const totalWin = game.tree.findByName('bonus_game.wrapper_container.popup_outro_total_win_label');

        container.options.visible = true;

        totalWin.options.text = this.store.toFormatMoney(0);
        totalWin.updateViewOptions();

        await game.utils.GameUtils.playAlphaAnimation(container, {from: 0, to: 1, time: 500, timeWait: 0});

        game.emit(BonusGameComponent.events.OUTRO_POPUP_START_COUNT);

        this.isOutroPopupClicked = true;
        await Promise.race([
            game.utils.GameUtils.playCounterAnimation(totalWin, {
                from: 0,
                to: this.store.gameData.bonusGame.win,
                time: this.timePlayCounterAnimation,
                timeWait: 0,
                minTimeForUpdate: 0
            }).then(() => {
                this.isOutroPopupClicked = false;
            }),
            this.waitClick(),
            game.onceDataPromise('Button.clicked', {
                component: 'bonusGame',
                name: 'bonus_game.popup_outro.wrapper_container.skip'
            })
        ]);

        game.utils.removeCall(totalWin._tween);

        totalWin.options.text = this.store.toFormatMoney(this.store.gameData.bonusGame.win);
        totalWin.updateViewOptions();

        game.emit(BonusGameComponent.events.OUTRO_POPUP_END_COUNT);

        if (this.isOutroPopupClicked || this.isIntroPopupClicked) {
            await game.utils.delay(this.timeWaitStopPlayCounterAnimation);
        } else {
            await game.utils.delay(this.timeOutroTransitionSound - this.timePlayCounterAnimation);
        }

        this.isIntroPopupClicked = false;

        game.emit(BonusGameComponent.events.START_HIDE_END_INTRO_POPUP);
        await game.utils.GameUtils.playAlphaAnimation(container, {from: 1, to: 0, time: 500, timeWait: 0});
    }

    async showOutroJackpotPopup() {
        this.onChangeOrientation();
        //@ts-ignore
        this.view.forceViewUpdate();

        const container = game.tree.findByName("bonus_game.wrapper_container.jackpot_container");
        const totalWin = game.tree.findByName("bonus_game.wrapper_container.jackpot_container.total_win");
        let jackpotMultiplier;

        if (this.isPlatinumJackpot) jackpotMultiplier = CONST.JACKPOT.PLATINUM_MULTIPLIER;


        totalWin.options.text = this.store.toFormatMoney(0);
        totalWin.updateViewOptions();

        await game.utils.GameUtils.playAlphaAnimation(container, {from: 0, to: 1, time: 300, timeWait: 0});

        game.emit(BonusGameComponent.events.PLATINUM_POPUP_START_COUNT);
        game.utils.call(() => {
            game.emit(BonusGameComponent.events.PLATINUM_POPUP_END_COUNT);
        }, 5000);
        await game.utils.GameUtils.playCounterAnimation(totalWin, {
            from: 0,
            to: this.store.gameData.bet * jackpotMultiplier,
            time: 5000,
            timeWait: 2000,
            minTimeForUpdate: 40
        });

        game.emit("BonusGameComponent.START_HIDE_PLATINUM_POPUP");
        await game.utils.GameUtils.playAlphaAnimation(container, {from: 1, to: 0, time: 300, timeWait: 0});
    }

    async createCoinParticles() {
        await game.utils.delay(400)
        const backgroundWrapperContainer = game.tree.findByName('bonus_game.wrapper_container.jackpot_container.jackpot_coin_container');

        const particlesSmallUnder = this.createParticlesItem(
            'coinParticle',
            ["coin_00","coin_01","coin_02","coin_03","coin_04","coin_05","coin_06","coin_07","coin_08","coin_09","coin_10"]);

        backgroundWrapperContainer.addChild(particlesSmallUnder);
    }

    createParticlesItem(nameParticle: string, nameTextures: any){
        const config = {
            "alpha": {
                "start": 1,
                "end": 1
            },
            "scale": {
                "start": 1,
                "end": 1,
                "minimumScaleMultiplier": 1
            },
            "color": {
                "start": "#ffffff",
                "end": "#ffffff"
            },
            "speed": {
                "start": 2600,
                "end": 0,
                "minimumSpeedMultiplier": 0.5
            },
            "acceleration": {
                "x": 0,
                "y": 2700
            },
            "maxSpeed": 0,
            "startRotation": {
                "min": 240,
                "max": 300
            },
            "noRotation": false,
            "rotationSpeed": {
                "min": 50,
                "max": 250
            },
            "lifetime": {
                "min": 6,
                "max": 10
            },
            "blendMode": "normal",
            "frequency": 0.05,
            "emitterLifetime": -1,
            "maxParticles": 1500,
            "pos": {
                "x": 0,
                "y": 630
            },
            "addAtBack": false,
            "spawnType": "point"
        }

        return this.particleContainer = game.builder.create({
            "type": "Particles",
            "parentGroup": "TOP",
            "zOrder": 4,
            "name": nameParticle,
            "framerate": 20,
            "loop": true,
            'textures': nameTextures,
            "isStart": true,
            "particlesConfig": config,
        });
    }

    get gameData(): GameDataStore {
        return (<GameDataStore>this.store.gameData);
    }
}

export {BonusGameComponent};

//@ts-ignore
Game.src.component.BonusGameComponent = BonusGameComponent;